<template>
  <div :class="$style.newsArchivePage">
    <app-layout :render-left-column="false">
      <template slot="central-column">
        <div :class="$style['wrap']">
          <jtn-ui-side-block-header
              :class="$style['title']"
              :text="pageHeader"
              title-tag="h1"
          />
          <search-records-list
              v-if="showedResults"
              :class="$style['search-records-list']"
              :records="newsData"
              :params="dataBlock.params"
          />
          <jtn-ui-typography
              v-else
              :class="$style['notice']"
              :tag="'div'"
              :type="'font-photoday-type-1'"
          >
            Ничего не найдено
          </jtn-ui-typography>
          <jtn-ui-pagination
              v-model="pageData"
              v-if="showedResults"
              v-show="pageData.numPages && pageData.numPages > 1"
              :class="$style['pagination']"
              :items-per-page="params.pagesize"
              :total-items="totalResult"
              :first-page-url="firstPageUrl"
          />
        </div>
      </template>

      <template slot="right-column">
        <app-right-column/>
      </template>
    </app-layout>
  </div>
</template>

<script>
import { dateFormat } from '@portal/utils/util-date';
import {
  ACTUAL_RUBRICS_INFO,
  getRubricIdBySectionId,
  DEFAULT_DATE_FORMAT
} from '@jtnews/shared/data';
import { JtnUiPagination, JtnUiSideBlockHeader, JtnUiTypography } from '@jtnews/jtn-ui';

import AppLayout from '../../../layout/containers/app-layout';
import AppRightColumn from '../../../layout/containers/app-right-column';

import SearchRecordsList from '../containers/search-records-list.container';

import { PageAnalyticsMixin } from '../../../shared/mixins/page-analytics';
import { WindowScrollMixin } from '../../../shared/mixins/window-scroll.mixin';
import { getDateRange } from '../../../shared/utils/';

const PERIOD_MAP = {
  today: 'сегодня',
  yesterday: 'вчера',
  week: 'неделю'
};

export default {
  name: 'ArchiveByDatePage',
  components: {
    JtnUiSideBlockHeader,
    JtnUiPagination,
    JtnUiTypography,
    AppLayout,
    AppRightColumn,
    SearchRecordsList
  },
  mixins: [WindowScrollMixin, PageAnalyticsMixin],
  data() {
    return {
      rubricsList: ACTUAL_RUBRICS_INFO || {},
      params: {
        page: +this.$route.query.page || 1,
        pagesize: 40,
        dateTo: '',
        dateFrom: ''
      },
      pageData: {
        currentPage: parseInt(this.$route.query.page, 10) || 1
      },
      date: ''
    };
  },
  computed: {
    dataBlock() {
      return this.store.archivesModule.searchResultBlock;
    },
    newsData() {
      if (this.dataBlock.data) {
        return this.dataBlock.data;
      }

      return [];
    },
    totalResult() {
      if (this.dataBlock.meta) {
        return this.dataBlock.meta.total;
      }

      return 0;
    },
    // путь, по которому достпуны данные в store
    dataPath() {
      if (this.dataBlock.path) {
        return this.dataBlock.path;
      }

      return '';
    },
    showedResults() {
      return this.totalResult && this.newsData.length > 0;
    },
    pageHeader() {
      return this?.metatags?.h1 ? this.metatags.h1 : 'Новости';
    },
    firstPageUrl() {
      return this.$route.path || '';
    }
  },
  beforeMount() {
    const { relativePeriod } = this.$route.params;
    if (relativePeriod) {
      this.date = PERIOD_MAP[relativePeriod];
      this.params = {
        ...this.params,
        relativePeriod
      };
    } else {
      const { year, month, day } = this.$route.params;
      const { dateFrom, dateTo } = getDateRange(year, month, day);

      this.calcDate(year, month, day);

      this.params = {
        ...this.params,
        dateFrom,
        dateTo
      };
    }
    const rubric = this.$route.params.rubricId
        ? this.$route.params.rubricId
        : getRubricIdBySectionId(Number(this.$route.params.sectionId));

    this.params = {
      ...this.params,
      rubric
    };
  },
  methods: {
    calcDate(year, month, day) {
      let currentDateRange = '';
      let dateFormatType = '';

      if (day === undefined && month === undefined) {
        currentDateRange = `${year}`;
        dateFormatType = 'YYYY';
      } else if (day === undefined) {
        currentDateRange = `${year}-${month}-01T00:00:00`;
        dateFormatType = 'LLLL YYYY';
      } else {
        currentDateRange = `${year}-${month}-${day}T00:00:00`;
        dateFormatType = DEFAULT_DATE_FORMAT;
      }

      try {
        this.date = dateFormat(currentDateRange, dateFormatType);
      } catch (e) {
        this.date = '';
      }
    },
    getRubricNameByPath(rubricPath) {
      const rubric = this.rubricsList[rubricPath];
      if (rubric !== undefined) return rubric.value;
      return '';
    }
  }
};
</script>

<style lang="scss" module>
@import 'styles';
@import '../../../styles/news-archive-page';

.newsArchivePage {
  .title {
    margin-bottom: 0;
    padding: 0 0 10px 0;
  }

  .search-records-list {
    & article:first-child {
      border-top: none;
    }
  }
}
</style>
